import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceModel } from '../private/pages/invoices-module/models/invoice-model';
import { CoreProvider } from './core';

@Injectable({ providedIn: 'root' })
export class ApiqueryServiceProvider {

  private core: CoreProvider;
  constructor(private _http: HttpClient) {}

  public init(core: CoreProvider) {
    this.core = core;
  }

  private getToken(): string {
    return this.core.auth.token;
  }

  public rawQuery(action:string, requireLogin:boolean=false, data:any=null) {
    return this.doQuery(action, requireLogin, data);
  }

  getAccountingSummary(config) {
    return this.doQuery("Coin/GetSoldSummary", true, config);
  }

  getAllCarriers(idClient=null) {
    return this.doQuery("Carrier/GetAll", true, (idClient)?{Id_Client: idClient}:null);
  }

  getCarrierCustomFields(idCarrier) {
    return this.doQuery("Carrier/GetCustomFields", true, {Id: idCarrier});
  }

  getClientBlock(idClient, simpleInvoice=false) {
    return this.doQuery("Invoice/GetClientData", true, {Id: idClient, SimpleInvoice: simpleInvoice});
  }

  getCategoryRanking(id=null) {
    return this.doQuery("Order/GetCategoryRanking", true, {Id_User: id});
  }

  getOrder(id) {
    return this.doQuery("Order/Get", true, {Id: id});
  }

  putOrderInfo(order) {
    return this.doQuery("Order/PutOrderData", true, order);
  }

  cancelOrder(id) {
    return this.doQuery("Order/Cancel", true, {Id: id});
  }

  removeOrderItem(id) {
    return this.doQuery("Order/DeleteItem", true, {Id: id});
  }

  addOrderItem(idCoin, idOrder, priceOverride) {
    return this.doQuery("Order/AddItem", true, {
      Id_Coin: idCoin,
      Id_Order: idOrder,
      PriceOverride: priceOverride
    });
  }

  getNotes(idclient) {
    return this.doQuery("Notes/GetAllByClient", true, {id: idclient});
  }

  addNewOrderStatus(order) {
    return this.doQuery("Order/AddNewStatus", true, order);
  }

  revertLastStatus(order) {
    return this.doQuery("Order/RevertLastStatus", true, {Id: order.Id});
  }

  getOrderReport(orderlist) {
    return this.doQuery("Orderreport/Get", true, orderlist);
  }

  getOrderCoinDatasheetReport(orderlist) {
    return this.doQuery("Orderreport/GetCoinDatasheet", true, orderlist);
  }

  getCoinReport(data) {
    return this.doQuery("Coinreport/Get", true, data);
  }

  getOrderHistory(id) {
    return this.doQuery("Order/GetHistory", true, {Id_Order: id});
  }

  fetchRemoteShopOrder(query) {
    return this.doQuery("Catalogsync/FetchOrderAsNewModel", true, query);
  }

  markInvoicePaid(id) {
    return this.doQuery("Invoice/MarkAsPaid", true, {Id:id});
  }

  getCoinByRef(ref, withdetails = false) {
    return this.doQuery("Coin/GetByReference", true, {reference: ref, withdetails: withdetails});
  }

  importOrder(data) {
    return this.doQuery("Order/Import", true, data);
  }

  getOrdersByStatus(status) {
    return this.doQuery("Order/GetAllByStatus", true, {status:status});
  }

  getOrders(config) {
    return this.doQuery("Order/GetAll", true, config);
  }

  putNote(note) {
    return this.doQuery("Notes/Put", true, note);
  }

  putUser(user) {
    return this.doQuery("User/Put", true, user);
  }

  putTask(task) {
    return this.doQuery("Tasks/Put", true, task);
  }

  deleteNote(id) {
    return this.doQuery("Notes/Delete", true, {id: id});
  }

  getClientTasks(idclient) {
    return this.doQuery("Tasks/GetAllByClient", true, {id: idclient});
  }

  deleteClientTask(id) {
    return this.doQuery("Tasks/Delete", true, {id: id});
  }

  setOwnerId(id, ownerid) {
    return this.doQuery("User/UpdateOwner", true, {id: id, ownerid: ownerid});
  }

  setRating(id, rating) {
    return this.doQuery("User/UpdateRating", true, {id: id, rating: rating});
  }

  searchClients(searchString) {
    return this.doQuery("User/Search", true, {text: searchString});
  }

  searchClientByModel(model) {
    return this.doQuery("User/SearchByModel", true, model);
  }

  getAllPendingActions() {
    return this.doQuery("Action/GetAllPending", true);
  }

  getAllActions() {
    return this.doQuery("Action/GetAll", true);
  }

  putAction(action) {
    return this.doQuery("Action/Put", true, action);
  }

  deleteAction(action) {
    return this.doQuery("action/delete", true, action);
  }

  getAllPC(dictionary) {
    return this.doQuery("Envconfig/PCGetAll", true, {dictionary: dictionary});
  }

  addPC(dictionary, word) {
    return this.doQuery("Envconfig/PCAddWord", true, {dictionary: dictionary, word: word});
  }

  getStatuses(clazz) {
    return this.doQuery("Status/GetAllByClass", true, {'class': clazz});
  }

  getUsersByRoles(roleArr) {
    return this.doQuery("User/GetAllByRoles", true, {'roles': roleArr});
  }

  getStatusByCode(code) {
    return this.doQuery("Status/GetByCode", true, {'code': code});
  }

  getNextReference() {
    return this.doQuery("EnvConfig/GetNextReferenceNumber", true);
  }

  getInvoices(config: any = {}) {
    return this.doQuery("invoice/getall", true, config);
  }
  getInvoicesReport(config: any = {}) {
    return this.doQuery("invoice/getallreport", true, config);
  }

  getCoins(filters=null) {
    return this.doQuery("coin/getall", true, filters);
  }

  getCoin(id) {
    return this.doQuery("coin/get", true, {Id: id});
  }

  getCoinsFromInvoices(filters=null) {
    return this.doQuery("Coin/GetFromInvoices", true, filters);
  }

  getCoinHistory(id) {
    return this.doQuery("Coin/GetHistory", true, {Id: id});
  }

  getUser(id) {
    return this.doQuery("User/Get", true, {Id: id});
  }

  delImage(id) {
    return this.doQuery("resource/delete", true, {Id: id});
  }

  putCoin(coin) {
    return this.doQuery("coin/put", true, coin);
  }

  putCoinRange(data) {
    return this.doQuery("Coin/PutRange", true, data);
  }

  getEnvConfig(key) {
    return this.doQuery("envconfig/get", true, {Key: key});
  }

  getNotifications() {
    return this.doQuery("User/GetNotifications", true);
  }

  getAllShops() {
    return this.doQuery("Shop/GetAll", true);
  }

  getDefaultSyncShops() {
    return this.doQuery("Shop/GetDefaultSync", true);
  }

  getShops() {
    return this.doQuery("Shop/GetAll", true);
  }

  getStates() {
    return this.doQuery("State/GetAll", true);
  }

  getStateById(id) {
    return this.doQuery("State/Get", true, {Id: id});
  }

  deleteCoin(coin) {
    return this.doQuery("coin/delete", true, coin);
  }

  getCategories() {
    return this.doQuery("category/getall", true);
  }

  putCategory(category) {
    return this.doQuery("category/put", true, category);
  }

  deleteCategory(category) {
    return this.doQuery("category/delete", true, category);
  }

  getInvoice(id, apirest: boolean = false) {
    return this.doQuery("invoice/get", true, ((apirest) ? { "Id": id, "ApiRes": true } : { "Id": id }));
  }

  putInvoice(invoice: InvoiceModel) {
    return this.doQuery("invoice/put", true, invoice);
  }

  deleteInvoice(invoice) {
    return this.doQuery("invoice/delete", true, invoice);
  }

  private doQuery(action: String, autho: boolean, body: any = null): Observable<any> {
    this.core.console.debug("Req-APIRest[" + action + "@" + autho + "]: Body", body);

    throw new Error('Deprecated api call: '+action);
  }

}
